// import the CSS first and foremost, set the layer precedence
import '../styles/layers.css';
import '../styles/styles.css';
// Importing fonts as part of the package.
import './fonts/fonts.css';
// also storybook doesn't support aliases yet. Maybe a plugin?

import { FC, PropsWithChildren } from 'react';

import { merge } from 'lodash';

import {
  CSSVariablesResolver,
  ColorSchemeScript,
  MantineProvider,
  localStorageColorSchemeManager,
  MantineProviderProps
} from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { Notifications } from '@mantine/notifications';

import { uiTheme } from './theme';

import '../utils/dateutils';

const themeResolver: CSSVariablesResolver = (theme) => ({
  variables: {
    '--drawer-header-height': theme.other.drawerHeaderHeight,
    '--drawer-footer-height': theme.other.drawerFooterHeight
  },
  light: {},
  dark: {}
});

interface ThemeProviderProps extends MantineProviderProps {
  resolver?: CSSVariablesResolver;
}

const ThemeProvider: FC<PropsWithChildren<ThemeProviderProps>> = ({
  children,
  resolver,
  ...rest
}) => {
  const colorSchemeManager = localStorageColorSchemeManager({
    key: 'falcon-app-color-scheme'
  });

  const mergedResolver = (theme: any) => {
    if (resolver) {
      return merge(themeResolver(theme), resolver(theme));
    }
    return themeResolver(theme);
  };

  return (
    <>
      <ColorSchemeScript defaultColorScheme={'light'} />
      <MantineProvider
        theme={uiTheme}
        defaultColorScheme={'light'}
        colorSchemeManager={colorSchemeManager}
        cssVariablesResolver={mergedResolver}
        {...rest}
      >
        <DatesProvider settings={{}}>
          <Notifications transitionDuration={100} />
          {children}
        </DatesProvider>
      </MantineProvider>
    </>
  );
};

const StoryBookThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <MantineProvider
      defaultColorScheme={'auto'}
      cssVariablesResolver={themeResolver}
      theme={uiTheme}
    >
      <DatesProvider
        settings={{
          locale: 'en-in',
          timezone: 'Asia/Kolkata'
        }}
      >
        {children}
      </DatesProvider>
    </MantineProvider>
  );
};

export { StoryBookThemeProvider, ThemeProvider };
